<template>
  <div class="mr-top-30">
  <!-- Page Title-->
  <div class="page-title">
      <div class="container">
        <h1>Votre Panier</h1>
        <ul class="breadcrumbs">
          <li><a href="index.html">Accueil</a>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li>Panier</li>
        </ul>
      </div>
    </div>

    <!-- Page Content-->
    <div class="container padding-bottom-3x mb-1">
      <!-- Alert-->
      <div id="alert" v-if="true" class="alert alert-info alert-dismissible fade show text-center">
      <span class="alert-close" data-dismiss="alert">
        </span><i class="material-icons redeem lead">
          </i>&nbsp;&nbsp;<strong>VOTRE PANIER</strong>
          </div>
      <!-- Shopping Cart-->
      <div class="table-responsive shopping-cart">
        <table class="table">
          <thead>
            <tr>
              <th>Référence (s)</th>
              <th class="text-center">Quantité</th>
              <th class="text-center">Prix</th>
              <div class="view-button"><a class="btn btn-danger" href="/#/promo">Bénificier de la promo</a></div>
              <th class="text-center">Total</th>
              <th class="text-center"><a class="btn btn-sm btn-outline-danger" href="#" @click="clearCart()">Vider votre panier</a></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" v-bind:key="product.id">
              <td>
                <div class="product-item"><a class="product-thumb"
                 href="shop-single.html">
                 <img :src="product.img" alt="Product"></a>
                  <div class="product-info">
                    <h4 class="product-title">
                      <a href="shop-single.html">{{product.id}}</a>
                      </h4><span><em>Marque:</em> {{product.name}}</span><span><em>Description : </em>{{product.description}}</span>


                  </div>

                </div>
              </td>
              <td class="text-center">
                <div class="count-input">
                  <div>
                    {{product.quantity}}
                  </div>
                </div>
              </td>
              <!--<td class="text-center">
                <div class="count-input">
                  <select class="form-control">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
              </td>
              -->
              <td class="text-center text-lg text-medium">{{product.price}}</td>
              <td class="text-center text-lg text-medium">{{product.price}}</td>
              <td class="text-center"><a class="remove-from-cart" href="#" data-toggle="tooltip" title="Remove item" @click="removeItem(product)"><i class="material-icons icon_close"></i></a></td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="shopping-cart-footer">
        <div class="column text-lg">Total à payer: <span class="text-medium text-dark">{{total}} DA</span></div>
      </div>
      <div class="shopping-cart-footer">
        <div class="column">
          <router-link class="btn btn-outline-secondary" to="/all">
            <i class="icon-arrow-left"></i>&nbsp;Retour à l'accueil</router-link></div>

        <div class="column">
          <router-link class="btn btn-success" to="/checkout" :disabled="!products.length">Commander</router-link>

        </div>
      </div>
      <!-- Related Products Carousel-->

    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      products: 'cartProducts'
    }),
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    }
  },
  methods: {
    checkout() {
      alert('Pay us $' + this.total);
    },
    ...mapActions(['clearCart', 'removeItem'])
  }
};
</script>

<style scoped>
.mr-top-30 {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/cart.vue